import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
const useStyles = makeStyles()((theme) => ({
  menuGroupTitle: {
    margin: theme.spacing(2, 3, 1)
  }
}));
function MenuGroupTitle({ title }) {
  const { classes } = useStyles();
  return /* @__PURE__ */ React.createElement("div", { className: classes.menuGroupTitle }, /* @__PURE__ */ React.createElement(Typography, { variant: "caption" }, /* @__PURE__ */ React.createElement(LocalizedText, { label: title })));
}
export {
  MenuGroupTitle
};
//# sourceMappingURL=MenuGroupTitle.js.map
